import { ESTADO_CESION } from "api/Types/EstadoCesion"
import { ESTADO_VERIFICACION_EFECTO } from "api/Types/EstadoVerificacionEfecto"
import { QUERY_PARAMETERS } from "common/constants"
import AlbaranService from "common/services/AlbaranService"
import FacturaService from "common/services/FacturaService"
import PedidoService from "common/services/PedidoService"
import PresupuestoService from "common/services/PresupuestoService"

export const INITIAL_PRE_DATA_CESIONES = {
  estadoRevision: {
    Pendiente: false,
    Verificado: false,
    Rechazado: false,
  },
}

export const INITIAL_PRE_DATA_FINANCIACION = {
  amount: {
    min: 0,
    max: 10000,
  },
  estadoRevision: {
    Pendiente: false,
    Validado: false,
    Rechazado: false,
  },
  date: {
    min: "dd-mm-aaaa",
    max: "dd-mm-aaaa",
  },
}

export const DEFAULT_ANY_VALIDATIONS = {
  cesiones: false,
  facturas: false,
  pagares: false,
}

export const DEFAULT_PENDING_VALIDATIONS = {
  cesiones: false,
  facturas: false,
  pagares: false,
  documentos: false,
  all: false,
}

export const DEFAULT_PENDING_DOCUMENTOS = {
  total: 0,
  facturas: 0,
  albaranes: 0,
  pedidos: 0,
  presupuestos: 0,
}

export const DOCUMENT_TYPE_SERVICE = {
  2: {
    label: "Factura",
    service: FacturaService,
  },
  18: {
    label: "Albarán",
    service: AlbaranService,
  },
  24: { label: "Pedido", service: PedidoService },
  25: {
    label: "Presupuesto",
    service: PresupuestoService,
  },
}

export const handleCreateQueryConfig = (
  queryKey: $TSMigrationFixMe,
  queryValue: $TSMigrationFixMe,
  data = {}
) => {
  return {
    key: queryKey,
    query: queryValue,
    data,
  }
}

export const VALIDACIONES_TABS = {
  AUTORIZACIONES: "AUTORIZACIONES",
  CESIONES: "CESIONES",
}

export const ESTADOS_VALIDACION = {
  AUTORIZACIONES: {
    PENDIENTE: 0,
    VERIFICADO: 1,
    RECHAZADO: 2,
  },
  CESIONES: {
    PENDIENTE: 1,
    COMUNICADA: 2,
    VERIFICADO: 4,
    RECHAZADO: 7,
  },
}

export const INIITAL_ESTADO_REVISION = {
  [ESTADO_CESION.CREADA]: false,
  [ESTADO_CESION.COMUNICADA]: false,
  [ESTADO_CESION.ACEPTADA_MANUALMENTE]: false,
  [ESTADO_CESION.ACEPTADA]: false,
  [ESTADO_CESION.CANCELADA]: false,
  [ESTADO_CESION.FINALIZADA]: false,
  [ESTADO_CESION.RECHAZADA]: false,
}

// @ts-expect-error TS(7006): Parameter 't' implicitly has an 'any' type.
export const ESTADOS_VALIDACION_INFO = (t, tab) => ({
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  [ESTADOS_VALIDACION[tab].PENDIENTE]: {
    backgroundColor: "#FFF6ED",
    color: "#FF7D00",
    text: `${t("validaciones.cesiones.table.filter.pendiente")}`,
  },

  ...(tab === VALIDACIONES_TABS.CESIONES
    ? {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
        [ESTADOS_VALIDACION[tab].COMUNICADA]: {
          backgroundColor: "#FFF6ED",
          color: "#FF7D00",
          text: `${t("validaciones.cesiones.table.filter.pendiente")}`,
        },
      }
    : {}),

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  [ESTADOS_VALIDACION[tab].VERIFICADO]: {
    backgroundColor: "#EDFCF5",
    color: "#00D770",
    text: `${t("validaciones.cesiones.table.filter.verificado")}`,
  },

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  [ESTADOS_VALIDACION[tab].RECHAZADO]: {
    backgroundColor: "#FCEFF0",
    color: "#DB222A",
    text: `${t("validaciones.cesiones.table.filter.rechazado")}`,
  },
})

// FIX: Remove this when redirections are implemented
export const getSearchParam = (
  from: $TSMigrationFixMe,
  hasCesiones: $TSMigrationFixMe,
  hasAutorizaciones: $TSMigrationFixMe
) => {
  const noMoreCesionesAfterVerifyCesionWithAutorizaciones =
    from === "cesiones" && hasAutorizaciones && !hasCesiones
  const hasMoreAutorizacionesAfterVerifyAutorizacion =
    from === "financiacion" && hasAutorizaciones
  const noMoreAutorizacionesAndCesionesAfterVerifyAutorizacion =
    from === "financiacion" && !hasAutorizaciones && !hasCesiones

  return noMoreCesionesAfterVerifyCesionWithAutorizaciones ||
    hasMoreAutorizacionesAfterVerifyAutorizacion ||
    noMoreAutorizacionesAndCesionesAfterVerifyAutorizacion
    ? ""
    : ""
}

export const CESIONES_QUERY_ESTADO_PENDING = `${QUERY_PARAMETERS.Estados}=${ESTADOS_VALIDACION.CESIONES.PENDIENTE}${QUERY_PARAMETERS.Estados}=${ESTADOS_VALIDACION.CESIONES.COMUNICADA}`
export const AUTORIZACIONES_QUERY_ESTADO_PENDING = `?${QUERY_PARAMETERS.Estados}=${ESTADO_VERIFICACION_EFECTO.COMUNICADO}${QUERY_PARAMETERS.Estados}=${ESTADO_VERIFICACION_EFECTO.PENDIENTE}`

export const VALIDATION_REDIRECTION_ORIGINS = {
  FINANCIACION: "financiacion",
  CONTACTOS: "contactos",
  CESIONES: "cesiones",
  DOCUMENTOS: "documentos",
}
